;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();type Props = {
  me?: {
    firstName?: string | null
    lastName?: string | null
    preferredFirstName?: string | null
    preferredLastName?: string | null
  } | null
  isLoggedIn?: boolean
}

export default function AttendeeName(_props: Props) {
  return <div className={"h-[30px]"} />
}
